import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list-os--sprite",
  "use": "list-os--sprite-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"list-os--sprite\"><path d=\"M840-120H120v-186h720v186Zm0-266H120v-189h720v189Zm0-269H120v-185h720v185Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol